import React from 'react'
import loaderImg from '@assets/loader_200_trasp.gif'   

interface LoaderModalProps {
	isOpen: boolean
	message?:string
}

const Loader: React.FC<LoaderModalProps> = ({ isOpen,message='Stiamo elaborando i dati...'}) => {
	if (!isOpen) return null


	return (
		<div className="fixed inset-0 flex items-center justify-center bg-(--background) z-1000 px-4">
			<div className="bg-white p-8 md:p-12 shadow-[0px_3px_10px_0px_#0000001A] w-full max-w-[336px] md:max-w-[600px] lg:max-w-[1076px] relative">


				{/* Testo */}
				<p className="text-[24px] md:text-[28px] font-semibold text-(--primary-blue) md:mb-6">
			  		{message}
				</p>

				{/* Loader immagine */}
				<div className="flex justify-center pb-5">
					<img
						src={loaderImg}
						alt="loader"
						className="w-[120px] h-[120px] animate-spin"
					/>
				</div>
			</div>
		</div>
	)
}

export default Loader;
